import { DateRangePicker, LocaleEnum } from '@systemeio/ui';
import { ChartBoxSection } from 'modules/main/components/chart-box-section';
import { EventBoxSection } from 'modules/main/components/event-box-section/event-box-section';
import { RevenueLimitNotification } from 'modules/main/components/revenue-limit-notification';
import { useMain } from 'modules/main/hooks/use-main';
import { MainFilterInterface } from 'modules/main/types/main-filter-interface';
import React, { useEffect, useRef } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import useWindowSize from 'shared/hooks/use-window-size';
import { useFilterWithDate } from 'shared/route-query/hooks/use-filter/use-filter-with-date';
import { getMonthDateRange, getToday } from 'shared/utils/get-dates';
import { twJoin } from 'tailwind-merge';
const defaultFilter: MainFilterInterface = {
  dateSince: null,
  dateTill: null
};
export const Main = () => {
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale,
    isFreemium
  } = useUser();
  const {
    filter,
    setFilter
  } = useFilterWithDate(defaultFilter, getMonthDateRange);
  const {
    revenue
  } = useMain(filter);
  const chartBoxRef = useRef<HTMLDivElement>(null);
  const eventBoxRef = useRef<HTMLDivElement>(null);
  const {
    width
  } = useWindowSize();
  const chartsHeight = chartBoxRef.current?.getBoundingClientRect().height;
  useEffect(() => {
    if (chartBoxRef.current && eventBoxRef.current && revenue) {
      if (Object.keys(revenue).length > 3 && width >= 1024) {
        eventBoxRef.current.style.height = `${chartsHeight}px`;
      } else if (width < 1024) {
        eventBoxRef.current.style.height = '';
      }
    }
  }, [chartsHeight, revenue, width]);
  return <div className={'mb-[53px] flex flex-col gap-5'}>
      {isFreemium && <RevenueLimitNotification />}
      <div className={`flex flex-col items-center justify-between gap-3 sm:flex-row`}>
        <h1 className="flex h-[42px] items-center whitespace-nowrap">
          {t('dashboard.main.title')}
        </h1>
        <div className={'w-full sm:w-fit lg:w-[326px]'}>
          <DateRangePicker light maxDate={getToday(user?.timezone)} getDefaultDate={() => getMonthDateRange(user?.timezone)} date={[filter.dateSince, filter.dateTill]} onChange={date => {
          const [dateSince, dateTill] = date;
          setFilter({
            dateSince,
            dateTill
          });
        }} timezone={user?.timezone} createdAt={user?.createdAt} intlLocale={intlLocale} wrapperButtonInputClassName={twJoin((user?.dashboardLocale === LocaleEnum.PORTUGUESE || user?.dashboardLocale === LocaleEnum.SPANISH) && 'tracking-[-0.06em]')} />
        </div>
      </div>
      <div className={'relative flex flex-col justify-between gap-6 lg:flex-row'}>
        <ChartBoxSection ref={chartBoxRef} className={revenue && Object.keys(revenue).length > 3 ? 'w-full lg:w-[calc(100%-350px)]' : 'w-full'} filter={filter} />
        <EventBoxSection ref={eventBoxRef} filter={filter} />
      </div>
    </div>;
};
export default Main;